import React from 'react';
import { compose, pure } from 'recompose';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Linkify from 'react-linkify';
import ConfirmTextButton from '../atoms/ConfirmTextButton';
import RegisterTextButton from '../atoms/RegisterTextButton';

const styles = {
  wordBreak: {
    wordBreak: 'break-all',
    whiteSpace: 'break-spaces'
  },
  ngReasonCol: {
    minWidth: '400px',
    width: '500px'
  },
  addressCol: {
    minWidth: '100px',
    width: '200px',
    whiteSpace: 'break-spaces'
  },
  shopNameCol: {
    minWidth: '100px',
    width: '200px',
    whiteSpace: 'break-spaces'
  },
  groupNameCol: {
    minWidth: '100px',
    width: '200px',
    whiteSpace: 'break-spaces'
  }
};

const enhance = compose(pure);

const ShopTableBody = enhance(
  ({
    classes,
    identities,
    emptyRows,
    page,
    rowsPerPage,
    registerOpenAction,
    confirmOpenAction,
    roles,
    orderBy,
    order
  }) => {
    const sortedResult = _.orderBy(identities, orderBy, order);
    return (
      <TableBody>
        {sortedResult
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(result => {
            const checkRegisterEnabled = status =>
              status === 'UNREGISTERED' || status === 'REJECTION';
            const checkConfirmEnabled = status =>
              status !== 'UNREGISTERED' ||
              status === 'RESERVED' ||
              status === 'REJECTION' ||
              status === 'NG';
            const params = {
              id: result.identityId,
              bankAccountHolder: result.bankAccountHolder,
              registeredCopyImage:
                result.identityImages && result.identityImages.length > 0
                  ? result.identityImages &&
                    result.identityImages
                      .filter(item => item.registeredCopy)
                      .map(item => item.registeredCopy)
                  : []
            };
            const key = `${result.identityId}-${result.groupId}`;
            return (
              <TableRow key={key}>
                <TableCell>
                  <RegisterTextButton
                    params={params}
                    onClickAction={registerOpenAction}
                    enabled={checkRegisterEnabled(result.status)}
                  />
                </TableCell>
                {(roles.isSecretariat || roles.isDeveloper) && (
                  <TableCell>
                    <ConfirmTextButton
                      params={result}
                      onClickAction={confirmOpenAction}
                      enabled={checkConfirmEnabled(result.status)}
                    />
                  </TableCell>
                )}
                <TableCell>{result.registeredAt}</TableCell>
                <TableCell>{result.statusStr}</TableCell>
                <TableCell className={[classes.wordBreak, classes.ngReasonCol]}>
                  <Linkify target="_blank">{result.ngReason}</Linkify>
                </TableCell>
                <TableCell className={classes.wordBreak}>
                  {result.adminMemo}
                </TableCell>
                {(roles.isSecretariat || roles.isDeveloper) && (
                  <TableCell className={classes.groupNameCol}>
                    {result.groupName}
                  </TableCell>
                )}
                <TableCell>{result.shopId}</TableCell>
                <TableCell className={[classes.shopNameCol]}>
                  {result.shopName}
                </TableCell>
                <TableCell className={[classes.addressCol]}>
                  {result.address}
                </TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={7} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(ShopTableBody);
